import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const ProjectsDetails = () => {
  const { projectsId } = useParams();
  const { loading, projects, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const findProjects =
    projects &&
    projects.find(
      (item) => slugify(`${item.id}-${item.name}`).toLowerCase() == projectsId
    );
  const stripHtml = (txt) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = txt;
    return tempDiv.textContent || tempDiv.innerText || "";
  };
  return (
    <>
      {findProjects && (
        <div className="section py-5">
          <div className="container">
            <div className="row max-mb-n50">
              <div className="col-lg-8 col-12 order-lg-1 max-mb-50">
                {/* Course Details Wrapper Start */}
                <div className="course-details-wrapper">
                  <div className="tab-content">
                    <div id="overview" className="tab-pane fade show active">
                      <div className="course-overview">
                        <h3 className="title">
                          {language == "az"
                            ? findProjects.name
                            : language == "en"
                            ? findProjects.nameEn
                            : language == "ru"
                            ? findProjects.nameRu
                            : language == "tr"
                            ? findProjects.nameTr
                            : language == "de"
                            ? findProjects.nameDe
                            : language == "pl"
                            ? findProjects.namePl
                            : ""}
                          <img
                            src={findProjects.ico}
                            alt=""
                            className="img-fluid ms-3"
                            style={{ width: "50px" }}
                          />
                        </h3>
                        <img
                          src={findProjects.img}
                          alt=""
                          className="img-fluid w-100 py-3"
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              language == "az"
                                ? findProjects.text
                                : language == "en"
                                ? findProjects.textEn
                                : language == "ru"
                                ? findProjects.textRu
                                : language == "tr"
                                ? findProjects.textTr
                                : language == "de"
                                ? findProjects.textDe
                                : language == "pl"
                                ? findProjects.textPl
                                : "",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Course Details Wrapper End */}
              </div>
              <div className="col-lg-4 col-12 order-lg-2 max-mb-50">
                <div className="sidebar-widget-wrapper pl-30 pl-md-0 pl-sm-0 pl-xs-0">
                  <div className="sidebar-widget">
                    <h3 className="sidebar-widget-title">{t.projectsother}</h3>
                    <div className="sidebar-widget-content">
                      <ul className="sidebar-widget-course">
                        {projects
                          .filter((i) => i.id !== findProjects.id)
                          .slice(0, 6)
                          .map((item) => {
                            return (
                              <NavLink
                                to={`/projects/${slugify(
                                  `${item.id}-${item.name}`
                                ).toLowerCase()}`}
                                onClick={() => window.scrollTo({ top: 0 })}
                              >
                                <li className="widget-course">
                                  <div
                                    className="thumbnail"
                                    style={{ border: "0" }}
                                  >
                                    <img
                                      src={item.ico}
                                      alt="Course Image"
                                      className="img-fluid"
                                      style={{ objectFit: "contain" }}
                                    />
                                  </div>
                                  <div className="info">
                                    <h6 className="title">
                                      <a href="#">
                                        {language == "az"
                                          ? item.name
                                          : language == "en"
                                          ? item.nameEn
                                          : language == "ru"
                                          ? item.nameRu
                                          : language == "tr"
                                          ? item.nameTr
                                          : language == "de"
                                          ? item.nameDe
                                          : language == "pl"
                                          ? item.namePl
                                          : ""}
                                      </a>
                                    </h6>
                                    <p>
                                      {item.text && language == "az"
                                        ? stripHtml(item.text).slice(0, 50)
                                        : language == "tr"
                                        ? stripHtml(item.textTr).slice(0, 50)
                                        : language == "en"
                                        ? stripHtml(item.textEn).slice(0, 50)
                                        : language == "ru"
                                        ? stripHtml(item.textRu).slice(0, 50)
                                        : ""}
                                      ...
                                    </p>
                                  </div>
                                </li>
                              </NavLink>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectsDetails;
